import { Clock, CheckCircle2, XCircle } from "lucide-react";

const normalize = (s: string) => String(s || "").toLowerCase().replace(/\s+/g, "_");

const STATUS_LABELS: Record<string, string> = {
  pending: "Pending",
  pending_approval: "Pending Approval",
  awaiting_approval: "Awaiting Approval",
  approved_by_leaders: "Approved by Leaders",
  approved: "Approved",
  ready_for_disbursement: "Ready for Disbursement",
  disbursed: "Disbursed",
  active: "Active",
  overdue: "Overdue",
  completed: "Completed",
  fully_repaid: "Fully Repaid",
  rejected: "Rejected",
  defaulted: "Defaulted",
  cancelled: "Cancelled",
  draft: "Draft",
};

const v: Record<string, string> = {
  pending: "bg-yellow-100 text-yellow-800 border-yellow-200",
  pending_approval: "bg-amber-100 text-amber-800 border-amber-200",
  awaiting_approval: "bg-amber-100 text-amber-800 border-amber-200",
  approved_by_leaders: "bg-blue-100 text-blue-800 border-blue-200",
  approved: "bg-blue-100 text-blue-800 border-blue-200",
  ready_for_disbursement: "bg-blue-100 text-blue-800 border-blue-200",
  active: "bg-green-100 text-green-800 border-green-200",
  disbursed: "bg-green-100 text-green-800 border-green-200",
  overdue: "bg-red-100 text-red-800 border-red-200",
  rejected: "bg-red-100 text-red-800 border-red-200",
  completed: "bg-green-100 text-green-800 border-green-200",
  fully_repaid: "bg-green-100 text-green-800 border-green-200",
  defaulted: "bg-red-100 text-red-800 border-red-200",
  cancelled: "bg-gray-100 text-gray-800 border-gray-200",
  draft: "bg-gray-100 text-gray-800 border-gray-200",
};

export function StatusBadge({ status }: { status: string }) {
  const normalized = normalize(status);
  const label = STATUS_LABELS[normalized] || status;
  const colors = v[normalized] || "bg-gray-100 text-gray-800";
  const showClock = ["pending", "pending_approval", "awaiting_approval"].includes(normalized);
  const showCheck = ["approved", "active", "completed", "fully_repaid", "disbursed"].includes(normalized);
  const showX = ["rejected", "defaulted"].includes(normalized);

  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border ${colors}`}>
      {showClock && <Clock className="h-3 w-3" />}
      {showCheck && <CheckCircle2 className="h-3 w-3" />}
      {showX && <XCircle className="h-3 w-3" />}
      {label}
    </span>
  );
}
